import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { AnalogSchema } from './analog.schema';

const c = initContract();
const pathPrefix = '/analog';

export const analogContract = c.router(
  {
    generateAnalogs: {
      method: 'POST',
      path: '/generate',
      body: z.object({
        smiles: z.string(),
        guidance: z.string(),
      }),
      responses: {
        200: z.object({
          analogs: z.array(AnalogSchema),
          debugInfo: z.string().optional(),
        }),
      },
    },
    generateAnalogExplanations: {
      method: 'POST',
      path: '/generate-explanations',
      body: z.object({
        smiles: z.string(),
        analogs: z.array(z.string()),
        guidance: z.string(),
      }),
      responses: {
        200: z.array(AnalogSchema),
      },
    },
  },
  {
    pathPrefix,
    validateResponseOnClient: true,
  }
);
